const { body } = document;
const html = document.querySelector('html');

function _blockScroll(event) {
  event.preventDefault();
}

export default class ScrollLock {
  static lock() {
    html.classList.add('scroll-locked');
    body.style.top = -1 * window.pageYOffset;
    body.addEventListener('scroll', _blockScroll, false);
  }

  static unlock() {
    html.classList.remove('scroll-locked');
    body.style.top = '';
    body.removeEventListener('scroll', _blockScroll, false);
  }
}
